import { Actions } from './action';
import { message } from 'antd';

const Reducer = (state, action) => {
	switch (action.type) {
		case Actions.GET_ALL_DELIVERABLES_DATA_SUCCESS:
		
			return {
				...state,
				deliverablesData: action.payload,
				isPageLoading: false,
			};
		case Actions.GET_ALL_DELIVERABLES_DATA_FAILED:
			message.error(action.payload);
			return state;

		case Actions.GET_ALL_ASSOCIATED_TENANTS_SUCCESS:
			return {
				...state,
				associatedTenants: action.payload,
			};
		case Actions.GET_ALL_ASSOCIATED_TENANTS_FAILED:
			message.error(action.payload);
			return state;

		case Actions.GET_ALL_PROJECTS_DATA_SUCCES:
			return {
				...state,
				projectsList: action.payload,
			};
		case Actions.GET_ALL_PROJECTS_DATA_FAILED:
			message.error(action.payload);
			return state;

		case Actions.GET_ALL_FILTERS_COUNT_SUCCESS:
			return {
				...state,
				filtersCount: action.payload,
				isStateLoading:false
			};
		case Actions.GET_ALL_FILTERS_COUNT_FAILED:
			message.error(action.payload);
			return state;

		case Actions.UPDATE_PAGE_LOADING_STATE:
			return {
				...state,
				[action.payload.type]: action.payload.data,
			};

		case Actions.UPADTE_CREATE_DELIVERABLE_MODAL_STATE:
			return {
				...state,
				[action.payload.type]: action.payload.data,
			};
		case Actions.GET_ALL_WORKSPACE_TENANT_DETAILS_SUCCESS:
			return {
				...state,
				workspaceTenants: action.payload,
			};
		case Actions.GET_ALL_WORKSPACE_TENANT_DETAILS_FAILED:
			message.error(action.payload);
			return state;

		case Actions.CREATE_NEW_DELIVERABLE_SUCCESS:
			message.success('Deliverable Created Successfully');
			return {
				...state,
				createNewDeliverableState: { status: 'success' },
			};

		case Actions.CREATE_NEW_DELIVERABLE_FAILED:
			return {
				...state,
				createNewDeliverableState: { status: 'failed', payload: action.payload },
			};
		case Actions.UPDATE_CREATE_DELIVERABLE_STATE:
			return {
				...state,
				[action.payload.type]: action.payload.data,
			};

		case Actions.GET_ALL_WORKSPACE_PROJECTS_LIST_DETAILS_SUCCESS:
			return {
				...state,
				workspaceProjectList: action.payload,
			};
		case Actions.GET_ALL_WORKSPACE_PROJECTS_LIST_DETAILS_FAILED:
			message.error(action.payload);
			return state;

		case Actions.UPDATE_DELIVERABLE_SUCCESS:
			message.success('Deliverable Updated Successfully');
			return {
				...state,
				UpdateDeliverableState: { status: 'success' },
			};

		case Actions.UPDATE_DELIVERABLE_FAILED:
			return {
				...state,
				UpdateDeliverableState: { status: 'failed', payload: action.payload },
			};
		case Actions.UPDATE_DELIVERABLE_CANCELED:
			return {
				...state,
				UpdateDeliverableState: { status: 'caneled'},
			}
		case Actions.PASSING_RECORD_DATA:
			return {
				...state,
				UpdateRecord:action.payload
			};
		default:
			return state;
	}
};

export default Reducer;
